import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import AddPhoneContent from "components/pages/AdvancedAlertsPage/components/AddPhoneContent";
import Classes from "model";

export default function CaptureNotifiLegacyAddPhone(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], AddPhoneContent)
    .submit();
    
    return <AdvancedAlertsPage ui={ ui } />
}